













import { Component, Prop, Mixins } from "vue-property-decorator";
import { IClient } from "@/models/clients";
import Context from "@/mixins/context";

@Component
export default class AdminClientInvoices extends Mixins(Context) {
  // Props
  @Prop({ default: () => () => [] })
  public routes!: () => any;

  @Prop({ required: true })
  public client!: IClient;

  public mounted() {
    this.$bus.$emit("scrollToTop");
  }

  public created() {
    if (this.isAdmin) {
      this.$store.commit("ui/breadcrumb/add", {
        key: "adminClient",
        value: `#${this.client.id}`
      });
    }
  }
}
